import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, BookOpen, Compass, Star } from 'lucide-react';
interface HomePageProps {
  setCurrentPage: (page: string) => void;
}
export const HomePage: React.FC<HomePageProps> = ({
  setCurrentPage
}) => {
  return <div className="space-y-16" data-id="element-148">
      <section className="text-center space-y-6 py-12 border-b border-gold/20 relative" data-id="element-149">
        <div className="absolute inset-0 bg-paper-pattern opacity-50 pointer-events-none" data-id="element-150" />
        <motion.h1 className="text-4xl md:text-6xl font-serif font-bold text-transparent bg-clip-text bg-gradient-to-r from-gold-dark via-gold to-gold-dark" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8
      }} data-id="element-151">
          探索生命的密码
        </motion.h1>
        <motion.p className="text-lg md:text-xl text-ink-light max-w-2xl mx-auto leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-152">
          八字命理，又称四柱推命，是中国传统文化中深奥而优美的哲学体系。
          通过天干地支的生克制化，洞察人生的起伏规律。
        </motion.p>
        <motion.div className="pt-8 flex flex-col sm:flex-row items-center justify-center gap-4" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-153">
          <button onClick={() => setCurrentPage('practical')} className="btn-primary flex items-center justify-center gap-2 text-lg" data-id="element-154">
            <Compass size={20} data-id="element-155" /> 立即排盘实战
          </button>
          <button onClick={() => setCurrentPage('tiangandizhi')} className="btn-secondary flex items-center justify-center gap-2 text-lg" data-id="element-156">
            <BookOpen size={20} data-id="element-157" /> 从零开始学习
          </button>
        </motion.div>
      </section>

      <section className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-158">
        <div className="bg-white ink-border p-8 rounded-lg card-hover cursor-pointer shadow-sm" onClick={() => setCurrentPage('tiangandizhi')} data-id="element-159">
          <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center text-gold-dark mb-6" data-id="element-160">
            <BookOpen size={24} data-id="element-161" />
          </div>
          <h3 className="text-xl font-serif font-bold mb-3 text-ink" data-id="element-162">
            系统化基础教程
          </h3>
          <p className="text-ink-light text-sm leading-relaxed mb-4" data-id="element-163">
            从最基础的天干地支、五行生克讲起，图文并茂，搭配互动组件，让小白也能轻松入门。
          </p>
          <span className="text-gold-dark font-medium text-sm flex items-center gap-1" data-id="element-164">
            开始学习 <ArrowRight size={14} data-id="element-165" />
          </span>
        </div>

        <div className="bg-white ink-border p-8 rounded-lg card-hover cursor-pointer shadow-sm" onClick={() => setCurrentPage('shishen')} data-id="element-166">
          <div className="w-12 h-12 bg-jade/10 rounded-full flex items-center justify-center text-jade mb-6" data-id="element-167">
            <Star size={24} data-id="element-168" />
          </div>
          <h3 className="text-xl font-serif font-bold mb-3 text-ink" data-id="element-169">
            进阶原理解析
          </h3>
          <p className="text-ink-light text-sm leading-relaxed mb-4" data-id="element-170">
            深入剖析十神关系、地支藏干、神煞吉凶，掌握断命的核心逻辑与推演技巧。
          </p>
          <span className="text-jade font-medium text-sm flex items-center gap-1" data-id="element-171">
            探索进阶 <ArrowRight size={14} data-id="element-172" />
          </span>
        </div>

        <div className="bg-white ink-border p-8 rounded-lg card-hover cursor-pointer shadow-sm" onClick={() => setCurrentPage('practical')} data-id="element-173">
          <div className="w-12 h-12 bg-cinnabar/10 rounded-full flex items-center justify-center text-cinnabar mb-6" data-id="element-174">
            <Compass size={24} data-id="element-175" />
          </div>
          <h3 className="text-xl font-serif font-bold mb-3 text-ink" data-id="element-176">
            智能排盘引擎
          </h3>
          <p className="text-ink-light text-sm leading-relaxed mb-4" data-id="element-177">
            内置精准的八字排盘工具，输入生辰即可生成详尽的命盘分析报告，学以致用。
          </p>
          <span className="text-cinnabar font-medium text-sm flex items-center gap-1" data-id="element-178">
            立即体验 <ArrowRight size={14} data-id="element-179" />
          </span>
        </div>
      </section>

      <section className="py-12 text-center" data-id="element-180">
        <blockquote className="text-2xl font-serif text-gold-dark/80 italic" data-id="element-181">
          "一阴一阳之谓道，生生之谓易。"
        </blockquote>
        <p className="text-ink-light mt-4" data-id="element-182">——《易经·系辞上》</p>
      </section>
    </div>;
};